/** @typedef {import('@/types/api').LastCompletedSaleSummary} LastCompletedSaleSummary */

const STORAGE_KEY = 'pos:last-completed-sale'

/**
 * @returns {Record<string, LastCompletedSaleSummary>}
 */
function readStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

/**
 * @param {number | string | null | undefined} branchId
 * @param {LastCompletedSaleSummary | null | undefined} sale
 */
export function rememberLastCompletedSale(branchId, sale) {
  if (!branchId || !sale?.id) return

  const stored = readStorage()
  stored[String(branchId)] = {
    id: sale.id,
    sale_number: sale.sale_number,
    completed_at: sale.completed_at ?? null,
    total: sale.total ?? null,
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
}

/**
 * @param {number | string | null | undefined} branchId
 * @returns {LastCompletedSaleSummary | null}
 */
export function getRememberedLastCompletedSale(branchId) {
  if (!branchId) return null
  return readStorage()[String(branchId)] ?? null
}

/**
 * @param {LastCompletedSaleSummary | null | undefined} sale
 */
export function canReprintLastReceipt(sale) {
  return Boolean(sale?.id)
}

/**
 * @param {LastCompletedSaleSummary | null | undefined} sale
 */
export function formatLastReceiptLabel(sale) {
  if (!sale?.sale_number) return 'Reprint last receipt'
  return `Reprint ${sale.sale_number}`
}
